import React, { useContext } from 'react'
import { createGlobalStyle, ThemeContext } from 'styled-components'

import { AgnosticTheme } from '@awazevr/design-system.components.awaze-theme-provider'
import { GlobalStyle } from '@awazevr/design-system.components.global-style'

const GlobalStyleVars = createGlobalStyle`
  html {
  /* Color */
  --main-bg-color: ${({ theme }) => theme.ColorThemeBackgroundPage};
  }
`

export const GlobalStyling = (): JSX.Element => {
  const themeContext = useContext(ThemeContext) || AgnosticTheme

  return (
    <>
      <GlobalStyleVars theme={themeContext} />
      <GlobalStyle />
    </>
  )
}
